window.AUTEL_COMPARE_DATA = {
  "DATA": {
    "MX808S": {
      "Link": "https://www.obdprice.com/products/autel-maxicheck-mx808s-obd2-scanner",
      "Price": 389,
      "RAM": "4G",
      "ROM": "64G",
      "battery capacity": "5000 mAh",
      "Android version": "Android 11",
      "Screen size": "7inch",
      "Screen resolution": "1024x600",
      "camera": "X",
      "HDMI": "Not Support",
      "Weight(kg)": "0.78 kg",
      "VCI": "main cable",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "X",
      "BMW online programming": "X",
      "Benz online coding (SCN)": "X",
      "BMW online coding": "X",
      "Audi online coding": "X",
      "Porsche online coding": "X",
      "VW online coding": "X",
      "BMW Hidden Brush": "X",
      "VW、Audi、Skoda Hidden Brush": "X",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "X",
      "Bently Guidance function": "X",
      "McLaren, Tesla diagnostic function": "X",
      "Auto VIN": "√",
      "SCAN VIN": "X",
      "Scan License": "X",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "X",
      "Bus protocol DoIP/CAN FD": "X",
      "Pre&Post Scan": "X",
      "WIFI printing": "X",
      "Oscilloscope function (with MP408)": "X",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "X",
      "Add EV box upgraded to EV product": "X",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "X",
      "Remote experts": "X",
      "AccuFix": "X",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "X",
      "language support": "Multi-Language",
      "Free upgrade years": "1-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
    "MK808Z": {
      "Link": "https://www.obdprice.com/products/autel-maxicom-mk808z-mk808s-automotive-diagnostic-scanner",
      "Price": 389,
      "RAM": "4G",
      "ROM": "64G",
      "battery capacity": "5000 mAh",
      "Android version": "Android 11",
      "Screen size": "7inch",
      "Screen resolution": "1024x600",
      "camera": "X",
      "HDMI": "Not Support",
      "Weight(kg)": "0.78 kg",
      "VCI": "main cable",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "X",
      "BMW online programming": "X",
      "Benz online coding (SCN)": "X",
      "BMW online coding": "X",
      "Audi online coding": "X",
      "Porsche online coding": "X",
      "VW online coding": "X",
      "BMW Hidden Brush": "X",
      "VW、Audi、Skoda Hidden Brush": "X",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "X",
      "Bently Guidance function": "X",
      "McLaren, Tesla diagnostic function": "X",
      "Auto VIN": "√",
      "SCAN VIN": "X",
      "Scan License": "X",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "X",
      "Bus protocol DoIP/CAN FD": "X",
      "Pre&Post Scan": "X",
      "WIFI printing": "X",
      "Oscilloscope function (with MP408)": "X",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "X",
      "Add EV box upgraded to EV product": "X",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "X",
      "Remote experts": "X",
      "AccuFix": "X",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "X",
      "language support": "Multi-Language",
      "Free upgrade years": "1-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
    "MK808BT Pro": {
      "Link": "https://www.obdprice.com/products/autel-maxicom-mk808bt-pro-obd2-diagnostic-tool",
      "Price": 459,
      "RAM": "4G",
      "ROM": "64G",
      "battery capacity": "5000 mAh",
      "Android version": "Android 11",
      "Screen size": "7inch",
      "Screen resolution": "1024x600",
      "camera": "X",
      "HDMI": "HDMI Type A",
      "Weight(kg)": "0.73 kg",
      "VCI": "VCI Mini",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "X",
      "BMW online programming": "X",
      "Benz online coding (SCN)": "X",
      "BMW online coding": "X",
      "Audi online coding": "X",
      "Porsche online coding": "X",
      "VW online coding": "X",
      "BMW Hidden Brush": "X",
      "VW、Audi、Skoda Hidden Brush": "X",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "X",
      "Bently Guidance function": "X",
      "McLaren, Tesla diagnostic function": "X",
      "Auto VIN": "√",
      "SCAN VIN": "X",
      "Scan License": "X",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "X",
      "Bus protocol DoIP/CAN FD": "X",
      "Pre&Post Scan": "X",
      "WIFI printing": "X",
      "Oscilloscope function (with MP408)": "X",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "√",
      "Add EV box upgraded to EV product": "X",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "X",
      "Remote experts": "X",
      "AccuFix": "X",
      "Report management (reports on the cloud)": "x",
      "Diagnostic system topology": "X",
      "language support": "Multi-Language",
      "Free upgrade years": "1-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
        "MX808S-TS": {
      "Link": "https://www.obdprice.com/products/autel-maxicheck-mx808ts-car-scanner",
      "Price": 589,
      "RAM": "4G",
      "ROM": "64G",
      "battery capacity": "5000 mAh",
      "Android version": "Android 11",
      "Screen size": "7inch",
      "Screen resolution": "1024x600",
      "camera": "X",
      "HDMI": "HDMI Type A",
      "Weight(kg)": "0.77 kg",
      "VCI": "VCI Mini",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "X",
      "BMW online programming": "X",
      "Benz online coding (SCN)": "X",
      "BMW online coding": "X",
      "Audi online coding": "X",
      "Porsche online coding": "X",
      "VW online coding": "X",
      "BMW Hidden Brush": "X",
      "VW、Audi、Skoda Hidden Brush": "X",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "X",
      "Bently Guidance function": "X",
      "McLaren, Tesla diagnostic function": "X",
      "Auto VIN": "√",
      "SCAN VIN": "X",
      "Scan License": "X",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "X",
      "Bus protocol DoIP/CAN FD": "X",
      "Pre&Post Scan": "X",
      "WIFI printing": "X",
      "Oscilloscope function (with MP408)": "X",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "√",
      "Add EV box upgraded to EV product": "X",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "√",
      "Remote experts": "X",
      "AccuFix": "X",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "X",
      "language support": "Multi-Language",
      "Free upgrade years": "1-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
    "MX900": {
      "Link": "https://www.obdprice.com/products/autel-maxicheck-mx900-obd2-all-system-diagnostic-scanner",
      "Price": 519,
      "RAM": "4G",
      "ROM": "64G",
      "battery capacity": "7700mAh",
      "Android version": "Android 11",
      "Screen size": "8 inch",
      "Screen resolution": "1280x800",
      "camera": "Rear:\n8MP",
      "HDMI": "Not Support",
      "Weight(kg)": "/",
      "VCI": "main cable",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "X",
      "BMW online programming": "X",
      "Benz online coding (SCN)": "X",
      "BMW online coding": "X",
      "Audi online coding": "X",
      "Porsche online coding": "X",
      "VW online coding": "X",
      "BMW Hidden Brush": "X",
      "VW、Audi、Skoda Hidden Brush": "X",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "X",
      "Bently Guidance function": "X",
      "McLaren, Tesla diagnostic function": "X",
      "Auto VIN": "√",
      "SCAN VIN": "√",
      "Scan License": "√",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "X",
      "Bus protocol DoIP/CAN FD": "√",
      "Pre&Post Scan": "√",
      "WIFI printing": "√",
      "Oscilloscope function (with MP408)": "X",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "X",
      "Add EV box upgraded to EV product": "X",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "X",
      "Remote experts": "X",
      "AccuFix": "X",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "X",
      "language support": "Multi-Language",
      "Free upgrade years": "1-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
    "MK900-BT": {
      "Link": "https://www.obdprice.com/products/autel-maxicom-mk900bt-full-system-diagnostic-scanner",
      "Price": 579,
      "RAM": "4G",
      "ROM": "64G",
      "battery capacity": "7700mAh",
      "Android version": "Android 11",
      "Screen size": "8 inch",
      "Screen resolution": "1280×800",
      "camera": "Rear:\n8MP",
      "HDMI": "Not Support",
      "Weight(kg)": "/",
      "VCI": "V150",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "X",
      "BMW online programming": "X",
      "Benz online coding (SCN)": "X",
      "BMW online coding": "X",
      "Audi online coding": "X",
      "Porsche online coding": "X",
      "VW online coding": "X",
      "BMW Hidden Brush": "X",
      "VW、Audi、Skoda Hidden Brush": "X",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "X",
      "Bently Guidance function": "X",
      "McLaren, Tesla diagnostic function": "X",
      "Auto VIN": "√",
      "SCAN VIN": "√",
      "Scan License": "√",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "X",
      "Bus protocol DoIP/CAN FD": "√",
      "Pre&Post Scan": "√",
      "WIFI printing": "√",
      "Oscilloscope function (with MP408)": "X",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "√",
      "Add EV box upgraded to EV product": "X",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "X",
      "Remote experts": "X",
      "AccuFix": "X",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "X",
      "language support": "Multi-Language",
      "Free upgrade years": "1-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
    "MX900-TS": {
      "Link": "https://www.obdprice.com/products/autel-maxicheck-mx900ts-all-system-diagnostic-scanner",
      "Price": 779,
      "RAM": "4G",
      "ROM": "64G",
      "battery capacity": "7700mAh",
      "Android version": "Android 11",
      "Screen size": "8 inch",
      "Screen resolution": "1280×800",
      "camera": "Rear:\n8MP",
      "HDMI": "Not Support",
      "Weight(kg)": "/",
      "VCI": "V150",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "X",
      "BMW online programming": "X",
      "Benz online coding (SCN)": "X",
      "BMW online coding": "X",
      "Audi online coding": "X",
      "Porsche online coding": "X",
      "VW online coding": "X",
      "BMW Hidden Brush": "X",
      "VW、Audi、Skoda Hidden Brush": "X",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "X",
      "Bently Guidance function": "X",
      "McLaren, Tesla diagnostic function": "X",
      "Auto VIN": "√",
      "SCAN VIN": "√",
      "Scan License": "√",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "X",
      "Bus protocol DoIP/CAN FD": "V",
      "Pre&Post Scan": "√",
      "WIFI printing": "√",
      "Oscilloscope function (with MP408)": "X",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "√",
      "Add EV box upgraded to EV product": "X",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "√",
      "Remote experts": "X",
      "AccuFix": "X",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "X",
      "language support": "English",
      "Free upgrade years": "1-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
    "MK900-TS": {
      "Link": "https://www.obdprice.com/products/autel-maxicom-mk900ts-wireless-tpms-diagnostic-scanner",
      "Price": 779,
      "RAM": "4G",
      "ROM": "64G",
      "battery capacity": "7700mAh",
      "Android version": "Android 11",
      "Screen size": "8 inch",
      "Screen resolution": "1280×800",
      "camera": "Rear:\n8MP",
      "HDMI": "Not Support",
      "Weight(kg)": "/",
      "VCI": "V150",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "X",
      "BMW online programming": "X",
      "Benz online coding (SCN)": "X",
      "BMW online coding": "X",
      "Audi online coding": "X",
      "Porsche online coding": "X",
      "VW online coding": "X",
      "BMW Hidden Brush": "X",
      "VW、Audi、Skoda Hidden Brush": "X",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "X",
      "Bently Guidance function": "X",
      "McLaren, Tesla diagnostic function": "X",
      "Auto VIN": "√",
      "SCAN VIN": "√",
      "Scan License": "√",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "X",
      "Bus protocol DoIP/CAN FD": "√",
      "Pre&Post Scan": "√",
      "WIFI printing": "√",
      "Oscilloscope function (with MP408)": "X",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "√",
      "Add EV box upgraded to EV product": "X",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "√",
      "Remote experts": "X",
      "AccuFix": "X",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "X",
      "language support": "Multi-Language",
      "Free upgrade years": "1-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
    "MP808S": {
      "Link": "https://www.obdprice.com/products/autel-maxipro-mp808-diagnostic-tool-full-system-obd2-scan-tool-mp808-with-bi-directional-control",
      "Price": 539,
      "RAM": "4G",
      "ROM": "64G",
      "battery capacity": "5000mA",
      "Android version": "Android 11",
      "Screen size": "7inch",
      "Screen resolution": "1024x600",
      "camera": "X",
      "HDMI": "Not Support",
      "Weight(kg)": "0.78 kg",
      "VCI": "main cable",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "X",
      "BMW online programming": "X",
      "Benz online coding (SCN)": "X",
      "BMW online coding": "√",
      "Audi online coding": "X",
      "Porsche online coding": "√",
      "VW online coding": "√",
      "BMW Hidden Brush": "√",
      "VW、Audi、Skoda Hidden Brush": "√",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "√",
      "Bently Guidance function": "X",
      "McLaren, Tesla diagnostic function": "X",
      "Auto VIN": "√",
      "SCAN VIN": "X",
      "Scan License": "X",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "X",
      "Bus protocol DoIP/CAN FD": "X",
      "Pre&Post Scan": "X",
      "WIFI printing": "X",
      "Oscilloscope function (with MP408)": "X",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "X",
      "Add EV box upgraded to EV product": "X",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "X",
      "Remote experts": "X",
      "AccuFix": "X",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "X",
      "language support": "Multi-Language",
      "Free upgrade years": "2-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
    "MP808BT Pro": {
      "Link": "https://www.obdprice.com/products/autel-maxipro-mp808bt-pro-automotive-diagnostic-scanner",
      "Price": 589,
      "RAM": "4G",
      "ROM": "64G",
      "battery capacity": "5000mA",
      "Android version": "Android 11",
      "Screen size": "7inch",
      "Screen resolution": "1024x600",
      "camera": "X",
      "HDMI": "HDMI Type\nA",
      "Weight(kg)": "0.73 kg",
      "VCI": "VCI Mini",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "X",
      "BMW online programming": "X",
      "Benz online coding (SCN)": "X",
      "BMW online coding": "√",
      "Audi online coding": "X",
      "Porsche online coding": "√",
      "VW online coding": "√",
      "BMW Hidden Brush": "√",
      "VW、Audi、Skoda Hidden Brush": "√",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "√",
      "Bently Guidance function": "X",
      "McLaren, Tesla diagnostic function": "X",
      "Auto VIN": "√",
      "SCAN VIN": "X",
      "Scan License": "X",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "X",
      "Bus protocol DoIP/CAN FD": "X",
      "Pre&Post Scan": "X",
      "WIFI printing": "X",
      "Oscilloscope function (with MP408)": "X",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "√",
      "Add EV box upgraded to EV product": "X",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "X",
      "Remote experts": "X",
      "AccuFix": "X",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "X",
      "language support": "Multi-Language",
      "Free upgrade years": "2-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
    "MP900": {
      "Link": "https://www.obdprice.com/products/autel-maxipro-mp900-mp900e-diagnostic-scanner",
      "Price": 699,
      "RAM": "4G",
      "ROM": "64G",
      "battery capacity": "7700 mAh",
      "Android version": "Android 11",
      "Screen size": "8 inch",
      "Screen resolution": "1280x800",
      "camera": "Rear:\n8MP",
      "HDMI": "Not Support",
      "Weight(kg)": "/",
      "VCI": "main cable",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "X",
      "BMW online programming": "X",
      "Benz online coding (SCN)": "X",
      "BMW online coding": "√",
      "Audi online coding": "X",
      "Porsche online coding": "√",
      "VW online coding": "√",
      "BMW Hidden Brush": "√",
      "VW、Audi、Skoda Hidden Brush": "√",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "√",
      "Bently Guidance function": "X",
      "McLaren, Tesla diagnostic function": "X",
      "Auto VIN": "√",
      "SCAN VIN": "√",
      "Scan License": "√",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "X",
      "Bus protocol DoIP/CAN FD": "√",
      "Pre&Post Scan": "√",
      "WIFI printing": "√",
      "Oscilloscope function (with MP408)": "X",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "X",
      "Add EV box upgraded to EV product": "X",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "X",
      "Remote experts": "X",
      "AccuFix": "X",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "X",
      "language support": "Multi-Language",
      "Free upgrade years": "1-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
    "MP900-TS": {
      "Link": "https://www.obdprice.com/products/autel-maxipro-mp900ts-diagnostic-scanner-with-full-tpms-functions",
      "Price": 949,
      "RAM": "4G",
      "ROM": "64G",
      "battery capacity": "7700 mAh",
      "Android version": "Android 11",
      "Screen size": "8 inch",
      "Screen resolution": "1280x800",
      "camera": "Rear:\n8MP",
      "HDMI": "Not Support",
      "Weight(kg)": 1,
      "VCI": "V150",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "X",
      "BMW online programming": "X",
      "Benz online coding (SCN)": "X",
      "BMW online coding": "√",
      "Audi online coding": "X",
      "Porsche online coding": "√",
      "VW online coding": "√",
      "BMW Hidden Brush": "√",
      "VW、Audi、Skoda Hidden Brush": "√",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "√",
      "Bently Guidance function": "X",
      "McLaren, Tesla diagnostic function": "X",
      "Auto VIN": "√",
      "SCAN VIN": "√",
      "Scan License": "√",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "X",
      "Bus protocol DoIP/CAN FD": "√",
      "Pre&Post Scan": "√",
      "WIFI printing": "√",
      "Oscilloscope function (with MP408)": "X",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "√",
      "Add EV box upgraded to EV product": "X",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "√",
      "Remote experts": "X",
      "AccuFix": "X",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "X",
      "language support": "Multi-Language",
      "Free upgrade years": "1-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
    "MP900-BT": {
      "Link": "https://www.obdprice.com/products/autel-maxipro-mp900bt-full-system-diagnostic-scanner",
      "Price": 799,
      "RAM": "4G",
      "ROM": "64G",
      "battery capacity": "7700 mAh",
      "Android version": "Android 11",
      "Screen size": "8 inch",
      "Screen resolution": "1280x800",
      "camera": "Rear:\n8MP",
      "HDMI": "Not Support",
      "Weight(kg)": "/",
      "VCI": "V150",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "X",
      "BMW online programming": "X",
      "Benz online coding (SCN)": "X",
      "BMW online coding": "√",
      "Audi online coding": "X",
      "Porsche online coding": "√",
      "VW online coding": "√",
      "BMW Hidden Brush": "√",
      "VW、Audi、Skoda Hidden Brush": "√",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "√",
      "Bently Guidance function": "X",
      "McLaren, Tesla diagnostic function": "X",
      "Auto VIN": "√",
      "SCAN VIN": "√",
      "Scan License": "√",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "X",
      "Bus protocol DoIP/CAN FD": "√",
      "Pre&Post Scan": "√",
      "WIFI printing": "√",
      "Oscilloscope function (with MP408)": "X",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "√",
      "Add EV box upgraded to EV product": "X",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "X",
      "Remote experts": "X",
      "AccuFix": "X",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "X",
      "language support": "Multi-Language",
      "Free upgrade years": "1-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
    "MS906 Pro": {
      "Link": "https://www.obdprice.com/products/autel-scanner-maxisys-ms906pro-car-diagnostic-scan-tool",
      "Price": 1059,
      "RAM": "4G",
      "ROM": "128G",
      "battery capacity": "11600mAh",
      "Android version": "Android 7.0",
      "Screen size": "8inch",
      "Screen resolution": "1920x1200",
      "camera": "Front:\n5MP",
      "HDMI": "HDMI 2.0",
      "Weight(kg)": 0.92,
      "VCI": "V200",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "X",
      "BMW online programming": "X",
      "Benz online coding (SCN)": "X",
      "BMW online coding": "√",
      "Audi online coding": "X",
      "Porsche online coding": "√",
      "VW online coding": "√",
      "BMW Hidden Brush": "√",
      "VW、Audi、Skoda Hidden Brush": "√",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "√",
      "Bently Guidance function": "√",
      "McLaren, Tesla diagnostic function": "X",
      "Auto VIN": "√",
      "SCAN VIN": "√",
      "Scan License": "√",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "X",
      "Bus protocol DoIP/CAN FD": "√",
      "Pre&Post Scan": "√",
      "WIFI printing": "√",
      "Oscilloscope function (with MP408)": "√",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "√",
      "Add EV box upgraded to EV product": "X",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "X",
      "Remote experts": "√",
      "AccuFix": "/",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "X",
      "language support": "Multi-Language",
      "Free upgrade years": "1-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
    "MK906S Pro": {
      "Link": "https://www.obdprice.com/products/autel-maxicom-mk906-pro-scanner",
      "Price": 1059,
      "RAM": "4G",
      "ROM": "128G",
      "battery capacity": "11600mAh",
      "Android version": "Android 10.0",
      "Screen size": "8inch",
      "Screen resolution": "1920x1200",
      "camera": "Frone/Rear:\n16MP",
      "HDMI": "HDMI 2.0",
      "Weight(kg)": "0.90 kg",
      "VCI": "V200",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "X",
      "BMW online programming": "X",
      "Benz online coding (SCN)": "X",
      "BMW online coding": "√",
      "Audi online coding": "X",
      "Porsche online coding": "√",
      "VW online coding": "√",
      "BMW Hidden Brush": "√",
      "VW、Audi、Skoda Hidden Brush": "√",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "√",
      "Bently Guidance function": "√",
      "McLaren, Tesla diagnostic function": "X",
      "Auto VIN": "√",
      "SCAN VIN": "√",
      "Scan License": "√",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "X",
      "Bus protocol DoIP/CAN FD": "√",
      "Pre&Post Scan": "√",
      "WIFI printing": "√",
      "Oscilloscope function (with MP408)": "X",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "√",
      "Add EV box upgraded to EV product": "X",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "X",
      "Remote experts": "X",
      "AccuFix": "X",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "X",
      "language support": "Multi-Language",
      "Free upgrade years": "1-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
    "MS906 Pro-TS": {
      "Link": "https://www.obdprice.com/products/autel-maxisys-ms906pro-ts-tpms-diagnostic-scanner",
      "Price": 1299,
      "RAM": "4G",
      "ROM": "128G",
      "battery capacity": "11600mAh",
      "Android version": "Android 7.0",
      "Screen size": "8inch",
      "Screen resolution": "1920x1200",
      "camera": "Front:\n5MP",
      "HDMI": "HDMI 2.0",
      "Weight(kg)": 0.962,
      "VCI": "V200",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "X",
      "BMW online programming": "X",
      "Benz online coding (SCN)": "X",
      "BMW online coding": "√",
      "Audi online coding": "X",
      "Porsche online coding": "√",
      "VW online coding": "√",
      "BMW Hidden Brush": "√",
      "VW、Audi、Skoda Hidden Brush": "√",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "√",
      "Bently Guidance function": "√",
      "McLaren, Tesla diagnostic function": "X",
      "Auto VIN": "√",
      "SCAN VIN": "√",
      "Scan License": "√",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "X",
      "Bus protocol DoIP/CAN FD": "√",
      "Pre&Post Scan": "√",
      "WIFI printing": "√",
      "Oscilloscope function (with MP408)": "√",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "√",
      "Add EV box upgraded to EV product": "X",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "√",
      "Remote experts": "√",
      "AccuFix": "/",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "X",
      "language support": "Multi-Language",
      "Free upgrade years": "1-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
    "MK906S Pro2-TS": {
      "Link": "https://www.obdprice.com/products/autel-maxicom-mk906s-pro-ii-ts",
      "Price": 1299,
      "RAM": "4G",
      "ROM": "128G",
      "battery capacity": "11600mAh",
      "Android version": "Android 10.0",
      "Screen size": "8inch",
      "Screen resolution": "1920x1200",
      "camera": "Frone/Rear:\n16MP",
      "HDMI": "HDMI 2.0",
      "Weight(kg)": "0.94 kg",
      "VCI": "V200",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "X",
      "BMW online programming": "X",
      "Benz online coding (SCN)": "X",
      "BMW online coding": "√",
      "Audi online coding": "X",
      "Porsche online coding": "√",
      "VW online coding": "√",
      "BMW Hidden Brush": "√",
      "VW、Audi、Skoda Hidden Brush": "√",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "√",
      "Bently Guidance function": "√",
      "McLaren, Tesla diagnostic function": "X",
      "Auto VIN": "√",
      "SCAN VIN": "√",
      "Scan License": "√",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "X",
      "Bus protocol DoIP/CAN FD": "√",
      "Pre&Post Scan": "√",
      "WIFI printing": "√",
      "Oscilloscope function (with MP408)": "X",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "√",
      "Add EV box upgraded to EV product": "X",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "√",
      "Remote experts": "X",
      "AccuFix": "X",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "X",
      "language support": "Multi-Language",
      "Free upgrade years": "1-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
    "MK908 II": {
      "Link": "https://www.obdprice.com/products/autel-maxicom-mk908-diagnostic-tool",
      "Price": 1288,
      "RAM": "4G",
      "ROM": "128G",
      "battery capacity": "15000mAh",
      "Android version": "Android 10",
      "Screen size": "10.1inch",
      "Screen resolution": "1920x1200",
      "camera": "Rear:\n16MP",
      "HDMI": "HDMI 2.0",
      "Weight(kg)": 1.58,
      "VCI": "Bluetooth box",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "X",
      "BMW online programming": "X",
      "Benz online coding (SCN)": "X",
      "BMW online coding": "√",
      "Audi online coding": "X",
      "Porsche online coding": "√",
      "VW online coding": "√",
      "BMW Hidden Brush": "√",
      "VW、Audi、Skoda Hidden Brush": "√",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "√",
      "Bently Guidance function": "√",
      "McLaren, Tesla diagnostic function": "/(Only Support McLaren)",
      "Auto VIN": "√",
      "SCAN VIN": "√",
      "Scan License": "√",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "X",
      "Bus protocol DoIP/CAN FD": "X",
      "Pre&Post Scan": "√",
      "WIFI printing": "√",
      "Oscilloscope function (with MP408)": "√",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "√",
      "Add EV box upgraded to EV product": "X",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "X",
      "Remote experts": "X",
      "AccuFix": "X",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "X",
      "language support": "Multi-Language",
      "Free upgrade years": "1-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
    "MS908S Pro II": {
      "Link": "https://www.obdprice.com/products/autel-maxisys-ms908s-pro-ii-diagnostic-scan-tool",
      "Price": 1649,
      "RAM": "4G",
      "ROM": "128G",
      "battery capacity": "11000mAh",
      "Android version": "Android 10",
      "Screen size": "9.7inch",
      "Screen resolution": "2048x1536",
      "camera": "Rear:\n16MP",
      "HDMI": "HDMI 2.0",
      "Weight(kg)": "/",
      "VCI": "Maxiflash Elite",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "√",
      "BMW online programming": "X",
      "Benz online coding (SCN)": "X",
      "BMW online coding": "√",
      "Audi online coding": "X",
      "Porsche online coding": "√",
      "VW online coding": "√",
      "BMW Hidden Brush": "√",
      "VW、Audi、Skoda Hidden Brush": "√",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "√",
      "Bently Guidance function": "√",
      "McLaren, Tesla diagnostic function": "/(Only Support McLaren)",
      "Auto VIN": "√",
      "SCAN VIN": "√",
      "Scan License": "√",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "X",
      "Bus protocol DoIP/CAN FD": "X",
      "Pre&Post Scan": "√",
      "WIFI printing": "√",
      "Oscilloscope function (with MP408)": "√",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "√",
      "Add EV box upgraded to EV product": "X",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "X",
      "Remote experts": "X",
      "AccuFix": "X",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "X",
      "language support": "Multi-Language",
      "Free upgrade years": "1-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
    "Elite II Pro": {
      "Link": "https://www.obdprice.com/products/autel-maxisys-elite-ii-automotive-diagnostic-tool",
      "Price": 2039,
      "RAM": "4G",
      "ROM": "128G",
      "battery capacity": "11000mAh",
      "Android version": "Android 10",
      "Screen size": "9.7\"",
      "Screen resolution": "1536*2048",
      "camera": "Rear:\n16MP",
      "HDMI": "Support",
      "Weight(kg)": 1.6,
      "VCI": "MaxiFlash VCI",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "√",
      "BMW online programming": "√",
      "Benz online coding (SCN)": "√",
      "BMW online coding": "√",
      "Audi online coding": "√",
      "Porsche online coding": "√",
      "VW online coding": "√",
      "BMW Hidden Brush": "√",
      "VW、Audi、Skoda Hidden Brush": "√",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "√",
      "Bently Guidance function": "√",
      "McLaren, Tesla diagnostic function": "√",
      "Auto VIN": "√",
      "SCAN VIN": "√",
      "Scan License": "√",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "√",
      "Bus protocol DoIP/CAN FD": "√",
      "Pre&Post Scan": "√",
      "WIFI printing": "√",
      "Oscilloscope function (with MP408)": "√",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "√",
      "Add EV box upgraded to EV product": "X",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "X",
      "Remote experts": "X",
      "AccuFix": "X",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "X",
      "language support": "Multi-Language",
      "Free upgrade years": "2-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
    "MS909": {
      "Link": "https://www.obdprice.com/products/autel-maxisys-ms909-with-maxiflash-vci",
      "Price": 2799,
      "RAM": "4G",
      "ROM": "128G",
      "battery capacity": "15000mAh",
      "Android version": "Android 7.0",
      "Screen size": "9.7inch",
      "Screen resolution": "2048X1536",
      "camera": "Front:\n5MP",
      "HDMI": "HDMI 2.0",
      "Weight(kg)": 1.7,
      "VCI": "MaxiFlash VCI",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "√",
      "BMW online programming": "√",
      "Benz online coding (SCN)": "√",
      "BMW online coding": "√",
      "Audi online coding": "√",
      "Porsche online coding": "√",
      "VW online coding": "√",
      "BMW Hidden Brush": "√",
      "VW、Audi、Skoda Hidden Brush": "√",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "√",
      "Bently Guidance function": "√",
      "McLaren, Tesla diagnostic function": "√",
      "Auto VIN": "√",
      "SCAN VIN": "√",
      "Scan License": "√",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "V",
      "Bus protocol DoIP/CAN FD": "√",
      "Pre&Post Scan": "√",
      "WIFI printing": "V",
      "Oscilloscope function (with MP408)": "X",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "√",
      "Add EV box upgraded to EV product": "√",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "X",
      "Remote experts": "√",
      "AccuFix": "√",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "√",
      "language support": "English",
      "Free upgrade years": "1-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
    "MS919": {
      "Link": "https://www.obdprice.com/products/autel-maxisys-ms919-with-maxiflash-vcmi",
      "Price": 3199,
      "RAM": "4G",
      "ROM": "128G",
      "battery capacity": "15000mAh",
      "Android version": "Android 7.0",
      "Screen size": "9.7inch",
      "Screen resolution": "2048X1536",
      "camera": "Front:\n5MP",
      "HDMI": "HDMI 2.0",
      "Weight(kg)": 1.7,
      "VCI": "MaxiFlash VCMI",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "√",
      "BMW online programming": "√",
      "Benz online coding (SCN)": "√",
      "BMW online coding": "√",
      "Audi online coding": "√",
      "Porsche online coding": "√",
      "VW online coding": "√",
      "BMW Hidden Brush": "√",
      "VW、Audi、Skoda Hidden Brush": "√",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "√",
      "Bently Guidance function": "√",
      "McLaren, Tesla diagnostic function": "√",
      "Auto VIN": "√",
      "SCAN VIN": "√",
      "Scan License": "√",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "√",
      "Bus protocol DoIP/CAN FD": "V",
      "Pre&Post Scan": "√",
      "WIFI printing": "V",
      "Oscilloscope function (with MP408)": "VCMI comes with",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "√",
      "Add EV box upgraded to EV product": "√",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "X",
      "Remote experts": "√",
      "AccuFix": "√",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "√",
      "language support": "English",
      "Free upgrade years": "1-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "/"
    },
        "Ultra Lite S": {
      "Link": "https://www.obdprice.com/products/autel-maxicom-ultra-lite-intelligent-diagnostic-scanner",
      "Price": 2849,
      "RAM": "4G",
      "ROM": "256G",
      "battery capacity": "18000mAh",
      "Android version": "Android 7.0",
      "Screen size": "12.9inch",
      "Screen resolution": "2732x2048",
      "camera": "Front:5MP\nRear:16MP",
      "HDMI": "HDMI 2.0",
      "Weight(kg)": 2.18,
      "VCI": "MaxiFlash VCI",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "√",
      "BMW online programming": "√",
      "Benz online coding (SCN)": "√",
      "BMW online coding": "√",
      "Audi online coding": "√",
      "Porsche online coding": "√",
      "VW online coding": "√",
      "BMW Hidden Brush": "√",
      "VW、Audi、Skoda Hidden Brush": "√",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "√",
      "Bently Guidance function": "√",
      "McLaren, Tesla diagnostic function": "√",
      "Auto VIN": "√",
      "SCAN VIN": "√",
      "Scan License": "√",
      "Remote Desk": "x",
      "Diagnostic standard D-PDU/RP1210": "x",
      "Bus protocol DoIP/CAN FD": "√",
      "Pre&Post Scan": "√",
      "WIFI printing": "√",
      "Oscilloscope function (with MP408)": "X",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "√",
      "Add EV box upgraded to EV product": "√",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "X",
      "Remote experts": "√",
      "AccuFix": "X",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "√",
      "language support": "Multi-Language",
      "Free upgrade years": "2-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
    "Ultra": {
      "Link": "https://www.obdprice.com/products/autel-maxisys-ultra-diagnostic-tool-with-advanced-vcmi",
      "Price": 3799,
      "RAM": "4G",
      "ROM": "256G",
      "battery capacity": "18000mAh",
      "Android version": "Android 7.0",
      "Screen size": "12.9inch",
      "Screen resolution": "2732x2048",
      "camera": "Front:\n5MP",
      "HDMI": "HDMI 2.0",
      "Weight(kg)": 2.18,
      "VCI": "MaxiFlash VCMI",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "√",
      "BMW online programming": "√",
      "Benz online coding (SCN)": "√",
      "BMW online coding": "√",
      "Audi online coding": "√",
      "Porsche online coding": "√",
      "VW online coding": "√",
      "BMW Hidden Brush": "√",
      "VW、Audi、Skoda Hidden Brush": "√",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "√",
      "Bently Guidance function": "√",
      "McLaren, Tesla diagnostic function": "√",
      "Auto VIN": "√",
      "SCAN VIN": "√",
      "Scan License": "√",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "V",
      "Bus protocol DoIP/CAN FD": "V",
      "Pre&Post Scan": "√",
      "WIFI printing": "V",
      "Oscilloscope function (with MP408)": "VCMI comes with",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "√",
      "Add EV box upgraded to EV product": "√",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "X",
      "Remote experts": "√",
      "AccuFix": "√",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "√",
      "language support": "English",
      "Free upgrade years": "1-Year",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    },
    "Ultra S2": {
      "Link": "https://www.obdprice.com/products/autel-maxisys-ultra-s2-diagnostic-scanner-tablet",
      "Price": 5459,
      "RAM": "12G",
      "ROM": "512G",
      "battery capacity": "18000mAh",
      "Android version": "Android 13.0",
      "Screen size": "13.7inch",
      "Screen resolution": "2176*1600",
      "camera": "R:16MP\nF:16MP",
      "HDMI": "Support",
      "Weight(kg)": "2.18",
      "VCI": "VCMI 2",
      "Basic functions (read code and clear code)": "√",
      "Service functions": "√",
      "Special functions": "√",
      "Active Test": "√",
      "Benz online programming": "√",
      "BMW online programming": "√",
      "Benz online coding (SCN)": "√",
      "BMW online coding": "√",
      "Audi online coding": "√",
      "Porsche online coding": "√",
      "VW online coding": "√",
      "BMW Hidden Brush": "√",
      "VW、Audi、Skoda Hidden Brush": "√",
      "VW、Audi、Skoda,Seat.Man LD Guidance function": "√",
      "Bently Guidance function": "√",
      "McLaren, Tesla diagnostic function": "√",
      "Auto VIN": "√",
      "SCAN VIN": "√",
      "Scan License": "√",
      "Remote Desk": "√",
      "Diagnostic standard D-PDU/RP1210": "V",
      "Bus protocol DoIP/CAN FD": "V",
      "Pre&Post Scan": "√",
      "WIFI printing": "V",
      "Oscilloscope function (with MP408)": "VCMI comes with",
      "Endoscope function (with MV108S)": "√",
      "Battery detection (BT506)": "√",
      "Add EV box upgraded to EV product": "√",
      "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "X",
      "Remote experts": "√",
      "AccuFix": "√",
      "Report management (reports on the cloud)": "√",
      "Diagnostic system topology": "√",
      "language support": "English",
      "Free upgrade years": "2-Year(Sold by OBDPRICE)",
      "Renault gateway support": "√",
      "North American FCA Auto auth support": "√",
      "European FCA SGW support": "√"
    }
  },
  "KEYS": [
    "Price",
    "RAM",
    "ROM",
    "battery capacity",
    "Android version",
    "Screen size",
    "Screen resolution",
    "camera",
    "HDMI",
    "Weight(kg)",
    "VCI",
    "Basic functions (read code and clear code)",
    "Service functions",
    "Special functions",
    "Active Test",
    "Benz online programming",
    "BMW online programming",
    "Benz online coding (SCN)",
    "BMW online coding",
    "Audi online coding",
    "Porsche online coding",
    "VW online coding",
    "BMW Hidden Brush",
    "VW、Audi、Skoda Hidden Brush",
    "VW、Audi、Skoda,Seat.Man LD Guidance function",
    "Bently Guidance function",
    "McLaren, Tesla diagnostic function",
    "Auto VIN",
    "SCAN VIN",
    "Scan License",
    "Remote Desk",
    "Diagnostic standard D-PDU/RP1210",
    "Bus protocol DoIP/CAN FD",
    "Pre&Post Scan",
    "WIFI printing",
    "Oscilloscope function (with MP408)",
    "Endoscope function (with MV108S)",
    "Battery detection (BT506)",
    "Add EV box upgraded to EV product",
    "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)",
    "Remote experts",
    "AccuFix",
    "Report management (reports on the cloud)",
    "Diagnostic system topology",
    "language support",
    "Free upgrade years",
    "Renault gateway support",
    "North American FCA Auto auth support",
    "European FCA SGW support"
  ],
  "LABELS": {
    "Price": "Price",
    "RAM": "RAM",
    "ROM": "Storage",
    "battery capacity": "Battery",
    "Android version": "Android",
    "Screen size": "Screen Size",
    "Screen resolution": "Screen Resolution",
    "camera": "Camera",
    "HDMI": "HDMI",
    "Weight(kg)": "Weight",
    "VCI": "VCI",
    "Basic functions (read code and clear code)": "Basic Diagnostics",
    "Service functions": "Service Functions",
    "Special functions": "Special Functions",
    "Active Test": "Active Test / Bi-Directional Control",
    "Benz online programming": "Mercedes-Benz Online Programming",
    "BMW online programming": "BMW Online Programming",
    "Benz online coding (SCN)": "Mercedes-Benz Online Coding (SCN)",
    "BMW online coding": "BMW Online Coding",
    "Audi online coding": "Audi Online Coding",
    "Porsche online coding": "Porsche Online Coding",
    "VW online coding": "VW Online Coding",
    "BMW Hidden Brush": "BMW Hidden Functions",
    "VW、Audi、Skoda Hidden Brush": "VW / Audi / Skoda Hidden Functions",
    "VW、Audi、Skoda,Seat.Man LD Guidance function": "VW / Audi / Skoda / SEAT Guided Functions",
    "Bently Guidance function": "Bentley Guided Functions",
    "McLaren, Tesla diagnostic function": "McLaren / Tesla Diagnostics",
    "Auto VIN": "Auto VIN",
    "SCAN VIN": "Scan VIN",
    "Scan License": "License Plate Scan",
    "Remote Desk": "Remote Desk",
    "Diagnostic standard D-PDU/RP1210": "D-PDU / RP1210",
    "Bus protocol DoIP/CAN FD": "DoIP / CAN FD",
    "Pre&Post Scan": "Pre & Post Scan",
    "WIFI printing": "Wi-Fi Printing",
    "Oscilloscope function (with MP408)": "Oscilloscope (with MP408)",
    "Endoscope function (with MV108S)": "Endoscope (MV108S)",
    "Battery detection (BT506)": "Battery Test (BT506)",
    "Add EV box upgraded to EV product": "EV Diagnostics Expansion",
    "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "Comprehensive TPMS Functions",
    "Remote experts": "Remote Expert",
    "AccuFix": "AccuFix",
    "Report management (reports on the cloud)": "Cloud Report Management",
    "Diagnostic system topology": "Diagnostic Topology",
    "language support": "Languages",
    "Free upgrade years": "Free Software Updates",
    "Renault gateway support": "Renault Gateway",
    "North American FCA Auto auth support": "FCA AutoAuth (North America)",
    "European FCA SGW support": "FCA SGW (Europe)"
  },
  "GROUPS": {
    "Price": "Hardware & Price",
    "RAM": "Hardware & Price",
    "ROM": "Hardware & Price",
    "battery capacity": "Hardware & Price",
    "Android version": "Hardware & Price",
    "Screen size": "Hardware & Price",
    "Screen resolution": "Hardware & Price",
    "camera": "Hardware & Price",
    "HDMI": "Hardware & Price",
    "Weight(kg)": "Hardware & Price",
    "VCI": "Hardware & Price",
    "Basic functions (read code and clear code)": "Functions",
    "Service functions": "Functions",
    "Special functions": "Functions",
    "Active Test": "Functions",
    "Benz online programming": "Functions",
    "BMW online programming": "Functions",
    "Benz online coding (SCN)": "Functions",
    "BMW online coding": "Functions",
    "Audi online coding": "Functions",
    "Porsche online coding": "Functions",
    "VW online coding": "Functions",
    "BMW Hidden Brush": "Functions",
    "VW、Audi、Skoda Hidden Brush": "Functions",
    "VW、Audi、Skoda,Seat.Man LD Guidance function": "Functions",
    "Bently Guidance function": "Functions",
    "McLaren, Tesla diagnostic function": "Functions",
    "Auto VIN": "Functions",
    "SCAN VIN": "Functions",
    "Scan License": "Functions",
    "Remote Desk": "Functions",
    "Diagnostic standard D-PDU/RP1210": "Protocols",
    "Bus protocol DoIP/CAN FD": "Protocols",
    "Pre&Post Scan": "Functions",
    "WIFI printing": "Functions",
    "Oscilloscope function (with MP408)": "Expansion & Accessories",
    "Endoscope function (with MV108S)": "Expansion & Accessories",
    "Battery detection (BT506)": "Expansion & Accessories",
    "Add EV box upgraded to EV product": "Expansion & Accessories",
    "\"TPMS comprehensive functions\"\n(sensor programming, sensor activation, etc.)": "Expansion & Accessories",
    "Remote experts": "Functions",
    "AccuFix": "Functions",
    "Report management (reports on the cloud)": "Functions",
    "Diagnostic system topology": "Functions",
    "language support": "Software & Support",
    "Free upgrade years": "Software & Support",
    "Renault gateway support": "Functions",
    "North American FCA Auto auth support": "Functions",
    "European FCA SGW support": "Functions"
  }
};
